/* tslint:disable */
/* eslint-disable */
/**
 * PostgREST API
 * This is a dynamic API generated by PostgREST
 *
 * The version of the OpenAPI document: 10.1.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OdysRoomUser
 */
export interface OdysRoomUser {
    /**
     * Note:
     * This is a Primary Key.<pk/>
     * This is a Foreign Key to `room.id`.<fk table='room' column='id'/>
     * @type {string}
     * @memberof OdysRoomUser
     */
    roomId: string;
    /**
     * Note:
     * This is a Primary Key.<pk/>
     * This is a Foreign Key to `user.id`.<fk table='user' column='id'/>
     * @type {string}
     * @memberof OdysRoomUser
     */
    userId: string;
    /**
     * 
     * @type {boolean}
     * @memberof OdysRoomUser
     */
    isOnline: boolean;
    /**
     * 
     * @type {string}
     * @memberof OdysRoomUser
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof OdysRoomUser
     */
    updatedAt: string;
}

export function OdysRoomUserFromJSON(json: any): OdysRoomUser {
    return OdysRoomUserFromJSONTyped(json, false);
}

export function OdysRoomUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): OdysRoomUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'roomId': json['room_id'],
        'userId': json['user_id'],
        'isOnline': json['is_online'],
        'createdAt': json['created_at'],
        'updatedAt': json['updated_at'],
    };
}

export function OdysRoomUserToJSON(value?: OdysRoomUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'room_id': value.roomId,
        'user_id': value.userId,
        'is_online': value.isOnline,
        'created_at': value.createdAt,
        'updated_at': value.updatedAt,
    };
}


